import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const WaterTreatmentPlantsRevamping: React.FC = () => {
  return (
    <>
      <PageHeader title="Water Treatment Plants Revamping" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Water Treatment Plants Revamping</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Aging water treatment infrastructure can lead to reduced efficiency, higher operating costs, and non-compliance with water quality standards. At Wasser Technochem (I) Ltd., we specialize in the revamping and modernization of existing Water Treatment Plants (WTPs), helping clients restore performance, optimize resource use, and extend the lifecycle of assets without major capex.</p>
              <p>We analyze current plant bottlenecks, design performance upgrades, and implement turnkey improvements that align with CPCB norms, ISO practices, and client-specific process goals.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-search text-primary me-2"></i>Detailed technical audit and plant performance evaluation</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-exchange-alt text-primary me-2"></i>Replacement of outdated filtration, softening, or DM systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-cogs text-primary me-2"></i>Upgradation of dosing, metering, and instrumentation systems</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-plug text-primary me-2"></i>Electrical and control panel retrofitting</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-desktop text-primary me-2"></i>SCADA integration and remote monitoring enablement</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-hammer text-primary me-2"></i>Structural repairs and layout redesign</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-flask text-primary me-2"></i>Chemical optimization for better throughput</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-graduation-cap text-primary me-2"></i>Post-revamp validation and operator training</p>
                </div>
              </div>

              <h3 className="mb-4">Common Revamp Areas</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-filter text-primary me-2"></i>Multimedia Filters</h5>
                      <p>Multimedia filters and activated carbon filters</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-recycle text-primary me-2"></i>Softener Systems</h5>
                      <p>Softener resin replacement and regeneration optimization</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-layer-group text-primary me-2"></i>RO/UF Membranes</h5>
                      <p>RO/UF membrane replacement and piping redesign</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-tachometer-alt text-primary me-2"></i>Flow Control</h5>
                      <p>Flow control systems, booster pumps, and VFDs</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-vial text-primary me-2"></i>Chemical Systems</h5>
                      <p>Chemical preparation and dosing systems</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Performance Restoration</h5>
                  <p>Restores design performance and improves treated water quality</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Reduced Downtime</h5>
                  <p>Minimizes plant downtime and energy consumption</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Extended Equipment Life</h5>
                  <p>Extends life of major equipment and civil infrastructure</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Cost Reduction</h5>
                  <p>Reduces chemical usage and operational costs</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Compliance</h5>
                  <p>Compliance with current safety and discharge norms</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-industry text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Brownfield Expertise</h5>
                      <p className="mb-0">Highly experienced in brownfield retrofits and WTP upgrades</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-users text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Multi-disciplinary Teams</h5>
                      <p className="mb-0">Multi-disciplinary teams for civil, mechanical, electrical, and instrumentation works</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-tools text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>System Expertise</h5>
                      <p className="mb-0">Expertise in DM, RO, filtration, and polishing systems</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-project-diagram text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>End-to-end Delivery</h5>
                      <p className="mb-0">End-to-end delivery: from audit to commissioning</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-handshake text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Long-term Support</h5>
                      <p className="mb-0">Long-term support through AMC and operator training</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default WaterTreatmentPlantsRevamping;
